import { setRoute } from '../../routes/actions/set';
import { bulk as bulkUpdateEvents } from './update';
import { bulk as bulkUpdateMarkets } from '../../markets/actions/update';
import { bulk as bulkUpdateCompetitions } from '../../competitions/actions/update';
import { bulk as bulkUpdateParticipants } from '../../participants/actions/update';
import { bulk as bulkUpdateSelections } from '../../selections/actions/update';
import { bulk as bulkUpdateSports } from '../../sports/actions/update';
import { push } from './push-recent';

export function request(id, name, silently) {
    id = parseInt(id, 10);

    return (dispatch, getState) => {
        let lastRoute = getState().events.get('last')

        if (isNaN(id)) {
            id = parseInt(lastRoute.eventId || getState().events.getIn([ 'opened', 0 ]), 10);
        }


            dispatch({
                type: 'EVENTS_OPEN_REQUEST',
                id,
                name
            });


        if (!silently) {
            dispatch(setRoute('events:' + id, lastRoute.parameters || {}));
        }
    };
}

export function error(id, errors) {
    id = parseInt(id, 10);

    return {
        type: 'EVENTS_OPEN_ERROR',
        id,
        errors
    };
}

export function finish(id, { events, markets, competitions, participants, selections, sports, tags }) {
    let event = events[0] || {};

    return (dispatch) => {
        dispatch(bulkUpdateSelections(selections));
        dispatch(bulkUpdateMarkets(markets));
        dispatch(bulkUpdateSports(sports));
        dispatch(bulkUpdateCompetitions(competitions));
        dispatch(bulkUpdateParticipants(participants));
        dispatch(bulkUpdateEvents(events));
        dispatch(push(event, competitions.filter(c => c.id === event.competition)[0]));

        dispatch({
            type: 'EVENTS_OPEN_FINISH',
            id: parseInt(id, 10),
            event
        });
    };
}

export function clear() {
    return {
        type: 'EVENTS_OPEN_CLEAR'
    };
}
